import SettingsScreen from "@/UI/screens/SettingsScreen";

export default function SettingsRoute() {
    return <SettingsScreen />;
}
